import { dataImageStar } from 'dls-icons-data'
import { createIcon } from '../common'

const IconImageStar = /*#__PURE__*/createIcon(dataImageStar)
export default IconImageStar
